import { Stats } from '@react-three/drei'
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'

import { CloseSvg, PerformanceSvg } from '@svg/react'

const VRAM_UNIT = 'MB'

export interface PerformanceStatsRef {
  setVRAM: (value: number) => void
}

interface PerformanceStatsProps {
  containerClassName?: string
  statsContainerClassName?: string
  VRAMContainerClassName?: string
  isPanelVisible?: boolean
  handleTogglePanel?: () => void
}

const PerformanceStats = forwardRef<PerformanceStatsRef, PerformanceStatsProps>(
  (
    {
      containerClassName = '',
      statsContainerClassName = '',
      VRAMContainerClassName = '',
      isPanelVisible,
      handleTogglePanel,
    },
    ref
  ) => {
    const [VRAM, setVRAM] = useState<number>()

    const parentRef = useRef<HTMLDivElement>(null)
    const buttonTitle = isPanelVisible
      ? 'Hide Performance Stats'
      : 'Show Performance Stats'

    useImperativeHandle(ref, () => ({
      setVRAM,
    }))

    return (
      <div className={`flex items-end gap-2 ${containerClassName}`}>
        <button
          type="button"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-500 hover:bg-gray-600"
          title={buttonTitle}
          onClick={handleTogglePanel}
        >
          {isPanelVisible ? (
            <CloseSvg className="h-3 w-3 stroke-white" />
          ) : (
            <PerformanceSvg className="h-7 w-7 fill-white stroke-white" />
          )}
        </button>
        {isPanelVisible && (
          <div
            className={`pointer-events-none relative flex h-full w-full gap-2 rounded bg-gray-600/90 p-2 ${statsContainerClassName}`}
            ref={parentRef}
          >
            <Stats
              parent={parentRef}
              showPanel={0}
              className="!relative order-1"
            />
            <Stats
              parent={parentRef}
              showPanel={1}
              className="!relative order-2"
            />
            <Stats
              parent={parentRef}
              showPanel={2}
              className="!relative order-3"
            />
            {VRAM !== undefined && (
              <div
                className={`order-4 text-gray-200 ${VRAMContainerClassName}`}
              >
                <p>VRAM:</p>
                <p className="flex items-center gap-1">
                  {VRAM || 0} <span className="text-xs">{VRAM_UNIT}</span>
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
)

export default PerformanceStats
